import { render, staticRenderFns } from "./HistoricalChannelTypeCount.vue?vue&type=template&id=53d3add4&"
import script from "./HistoricalChannelTypeCount.vue?vue&type=script&lang=ts&"
export * from "./HistoricalChannelTypeCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalChannelTypeCount.vue"
export default component.exports